import { isWish } from "./bookState";
import { getBookRegisteredDate } from "./format";

/**
 * 내 행성의 책을 표 파일(CSV)로 내보낸다.
 *
 * xlsx 가 아니라 csv 로 둔다. 엑셀·넘버스·구글 시트가 모두 그냥 열고,
 * 만드는 쪽에 라이브러리를 더하지 않아도 된다(SheetJS 는 압축해도 100KB 가
 * 넘어, 내보내기 한 번을 위해 모두가 매번 내려받게 된다).
 *
 * 엑셀이 한글을 깨뜨리지 않게 맨 앞에 BOM 을 붙이고, 줄 끝은 CRLF 로 둔다 —
 * 둘 중 하나만 빠져도 윈도우 엑셀에서 글자가 깨지거나 한 줄로 붙는다.
 */

/** 큰따옴표·쉼표·줄바꿈이 든 칸은 감싸고, 안의 따옴표는 두 번 쓴다 */
const cell = (v) => {
  const s = v == null ? "" : String(v);
  return /["\n\r,]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

const COLUMNS = ["제목", "저자", "장르", "상태", "등록일", "완독일", "밝음-어두움", "차분-격렬", "ISBN", "무루 링크"];

/** 감정 좌표는 내가 찍은 값만 쓴다. 남의 값은 내 기록이 아니다. */
const myEmotion = (book, uid) => (uid && book?.emotions && book.emotions[uid]) || null;

/** 등록일 견주기용. "2026.09.01" 과 "2026-9-1" 이 섞여 들어와도 같은 모양으로 만든다. */
const dayKey = (b, uid) => String(getBookRegisteredDate(b, uid) || "")
  .replace(/[.]/g, "-")
  .replace(/-(\d)(?=-|$)/g, "-0$1");

export function booksToCsv(books, uid) {
  /* 최근에 등록한 책이 위로. 파일을 열자마자 요즘 읽은 것이 보이는 편이
     낫다. 날짜가 같으면 제목 순으로 둬서 받을 때마다 순서가 바뀌지 않게 한다. */
  const sorted = [...(books || [])].sort((x, y) => {
    const a = dayKey(x, uid), b = dayKey(y, uid);
    if (a !== b) return b.localeCompare(a);
    return String(x.title ?? "").localeCompare(String(y.title ?? ""), "ko");
  });
  const rows = sorted.map((b) => {
    const done = (b.completedBy && uid && b.completedBy[uid]) || "";
    const em = myEmotion(b, uid);
    return [
      b.title, b.author, b.genre,
      isWish(b, uid) ? "읽고 싶은 책" : done ? "완독" : "읽는 중",
      getBookRegisteredDate(b, uid), done,
      em ? em.bright : "", em ? em.calm : "",
      b.isbn || "",
      b.isbn ? `https://muroo.kr/book/${b.isbn}` : "",
    ].map(cell).join(",");
  });
  return "﻿" + [COLUMNS.join(","), ...rows].join("\r\n") + "\r\n";
}

/** 오늘 날짜를 붙인 파일 이름 — 여러 번 받아도 서로 덮어쓰지 않게 */
export function csvFileName(today = new Date()) {
  const kst = new Date(today.getTime() + 9 * 3600000).toISOString().slice(0, 10);
  return `muroo-books-${kst}.csv`;
}
